/**
 * 
 * Column Defination
 * {
 *   ...Datagrid Column
 *   printWidth: number
 *   printType: "number" | "string" //default string
 *   printAlign: "left" | "center" | "right" //default left
 *   printMaxLength: number //default 13/1 char/inch
 *   printNullChar: string //default "-"
 * }
 */

import { blue, yellow } from "@mui/material/colors"
import { numberFormat } from "utils"
import { subStringTH } from "./substringTH"
import dayjs from "dayjs"



export const printTable = ({ doc, dataTable, columns, startX, startY, fontSize = 14, lineHeight = 0.21 }) => {
  let xPos = startX
  let yPos = startY
  doc.setFontSize(fontSize)

  const dataBoxW = columns.reduce((acc, col) => acc + (col.printWidth || 0.5), 0)

  xPos = startX
  yPos += lineHeight - 0.1
  doc.setFillColor(blue[100])
  doc.rect(xPos, yPos, dataBoxW, lineHeight + 0.1, "F")
  doc.line(xPos, yPos, xPos + dataBoxW, yPos)

  yPos += lineHeight

  for (const col of columns) {
    
    doc.text(col.headerName, xPos + (col.printWidth || 0.5) / 2, yPos, { align: "center" })
    xPos += col.printWidth || 0.5
  }

  yPos += 0.1
  doc.line(startX, yPos, startX + dataBoxW, yPos)
  yPos += lineHeight
  for (const row of dataTable) {
    xPos = startX
    
    if (row.id === 0) {
      //doc.setFont("THSarabun", "bold")
      doc.setFillColor(yellow[100])
      doc.rect(startX, yPos - 0.1, dataBoxW, lineHeight + 0.1, "F")
      doc.line(startX, yPos - 0.1, startX + dataBoxW, yPos - 0.1)
      yPos += 0.1
      
      doc.setFont("THSarabun", "bold")
    }
    for (const col of columns) {
      let printStr = ""
      if (col.printType === "number") {
        printStr = row[col.field] ? numberFormat(row[col.field]) : col.printNullChar || '-'
      } else if (col.printType === "datetime") {
        printStr = row[col.field] ? dayjs(row[col.field]).format(col.printFormat || "DD/MM HH:mm") : col.printNullChar || '-'
      } else {
        const str = row[col.field] ? `${row[col.field]}` : col.printNullChar || '-'
        printStr = subStringTH(str, col.printMaxLength || Math.floor((13 * col.printWidth || 0.5)))

      }
      const addX = col.printAlign === "center" ?
        (col.printWidth || 0.5) / 2 : col.printAlign === "right" ?
          (col.printWidth || 0.5) - 0.05 : 0.05
      doc.text(printStr, xPos + addX, yPos, { align: col.printAlign || "left" })
      xPos += col.printWidth || 0.5
    }
    yPos += lineHeight
    if (row.id === 0) {
      yPos -= 0.1
      doc.line(startX, yPos, startX + dataBoxW, yPos)
      doc.setFont("THSarabun", "normal")
    }
  }
  return yPos
}